import React, { useRef, useEffect, useState } from 'react';

export default function BlockingTooltip({ blockingReleases }) {
    const tooltipRef = useRef(null);
    const [showAbove, setShowAbove] = useState(false);
    const [alignRight, setAlignRight] = useState(false);

    useEffect(() => {
        if (tooltipRef.current) {
            const rect = tooltipRef.current.getBoundingClientRect();
            if (rect.bottom > window.innerHeight) {
                setShowAbove(true);
            }
            if (rect.right > window.innerWidth) {
                setAlignRight(true);
            }
        }
    }, []);

    const positionClass = showAbove ? 'bottom-full mb-1' : 'top-full mt-1';
    const alignClass = alignRight ? 'right-0' : 'left-0';

    return (
        <span
            ref={tooltipRef}
            className={`absolute ${alignClass} ${positionClass} px-2 py-1 text-xs text-black bg-white border border-gray-200 rounded shadow-lg opacity-0 group-hover:opacity-100 z-50 pointer-events-none`}
        >
            <div className="font-semibold mb-0.5">Blocked by:</div>
            {blockingReleases.map((br, i) => (
                <div key={i} className="whitespace-nowrap">
                    {'\u2022'} {br.releaseName} ({br.releaseStatus})
                </div>
            ))}
        </span>
    );
}